// extracted by mini-css-extract-plugin
export default {"imgdiv":"_2da12d7d46 _1e372f137f","img":"d7be85ac25 _3c5162e48e"};